export const BASE_URL = process.env.REACT_APP_BACKEND_API;

export const PRODUCTS_PER_PAGE = 8;
export const PRODUCTS_HOME_PAGE = 30;

export const LIMIT_QUANTITY_PRODUCT = 9;

export const CLOUDINARY_CLOUD_NAME =
    process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
export const CLOUDINARY_UPLOAD_PRESET =
    process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export const LIMIT_USERS_PER_PAGE = 10;
